/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SubmitCompletedWorkflowOfPaymentRequestsRequestEvidence
 */
export interface SubmitCompletedWorkflowOfPaymentRequestsRequestEvidence {
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestEvidence
     */
    'fileId': string;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestEvidence
     */
    'electronicMethod'?: SubmitCompletedWorkflowOfPaymentRequestsRequestEvidenceElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestEvidence
     */
    'documentSize'?: SubmitCompletedWorkflowOfPaymentRequestsRequestEvidenceDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestEvidence
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestEvidence
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestEvidence
     */
    'note'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestEvidence
     */
    'irrelevantToLedger'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestEvidence
     */
    'invoiceIssuerName': string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfPaymentRequestsRequestEvidence
     */
    'invoiceIssuerRegistrationNumber': string | null;
}

export const SubmitCompletedWorkflowOfPaymentRequestsRequestEvidenceElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type SubmitCompletedWorkflowOfPaymentRequestsRequestEvidenceElectronicMethodEnum = typeof SubmitCompletedWorkflowOfPaymentRequestsRequestEvidenceElectronicMethodEnum[keyof typeof SubmitCompletedWorkflowOfPaymentRequestsRequestEvidenceElectronicMethodEnum];
export const SubmitCompletedWorkflowOfPaymentRequestsRequestEvidenceDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type SubmitCompletedWorkflowOfPaymentRequestsRequestEvidenceDocumentSizeEnum = typeof SubmitCompletedWorkflowOfPaymentRequestsRequestEvidenceDocumentSizeEnum[keyof typeof SubmitCompletedWorkflowOfPaymentRequestsRequestEvidenceDocumentSizeEnum];


